module.exports = __webpack_public_path__ + "img/head-shoulders_hover.0fcda53b.png";